import { FC } from 'react';
import { NavigationItem } from 'components/navigation/utils/libs';
import { VerticalMenuItemWrapper } from '../VerticalMenuItemWrapper';
import { Tooltip, Icon } from '@kontentino/ui';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons/faEllipsis';
import useBoolean from 'utils/hooks/useBoolean';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import MenuLink from './MenuLink';

const MoreMenuTooltip: FC<{
  menuItems: NavigationItem[];
  activeItem?: NavigationItem;
}> = ({ menuItems, activeItem }) => {
  const [isOpen, setIsOpen] = useBoolean(false);
  const { t } = useTranslation();

  return (
    <Tooltip
      content={
        <div
          className={
            'tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-6 tw-py-4 tw-text-grayscale-180'
          }
        >
          {menuItems.map((menuItem, index) => (
            <MenuLink
              key={`${menuItem.key}-${index}`}
              item={menuItem}
              isActive={activeItem?.key === menuItem.key}
            />
          ))}
        </div>
      }
      placement="right"
      interactive
      interactiveBorder={10}
      interactiveDebounce={100}
      className="tw-w-[59px]  !tw-max-w-none tw-border !tw-border-none !tw-bg-white !tw-p-2 !tw-text-grayscale-180 tw-shadow-sm"
      appendTo={document.body}
      onShow={() => setIsOpen.on()}
      onHide={() => setIsOpen.off()}
      offset={[0, 14]}
      trigger="mouseenter click"
    >
      <VerticalMenuItemWrapper
        className="tw-flex tw-flex-col tw-items-center  hover:tw-cursor-pointer hover:tw-text-primary-100"
        isActiveMenu={isOpen}
      >
        <span
          className={clsx(
            'tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-p-1 hover:tw-cursor-pointer hover:tw-rounded-md hover:tw-bg-primary-10',
            {
              'tw-rounded-md tw-bg-primary-10': isOpen,
            },
          )}
        >
          <Icon icon={faEllipsis} size="lg" />
        </span>
        <span className="tw-text-xs">{t('more')}</span>
      </VerticalMenuItemWrapper>
    </Tooltip>
  );
};

export default MoreMenuTooltip;
